import React from 'react';

const EtatChocPage = ({formik, activeToggle = false}: { activeToggle?: boolean, formik }) => {
  return (
    <div className="grid grid-cols-1 gap-3 p-5 bg-white mx-auto px-5">
      <div>
        <div className="flex gap-4 items-center">
          <label className="flex items-center gap-1 text-xs">
            <input
              type="radio"
              name="type"
              className="w-3 h-3"
              data-value="Etat"
              defaultChecked={activeToggle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value="Etat"
            /> Etat
          </label>
          <label className="flex items-center gap-1 text-xs">
            <input
              type="radio"
              name="type"
              className="w-3 h-3"
              data-value="Choc"
              defaultChecked={!activeToggle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value="Choc"
            /> Choc
          </label>
        </div>
        {formik.errors.type ? <div className="text-xs text-red-600">
          {formik.errors.type}
        </div> : null}
      </div>
      <div>
        <label className="form-label">Libelle</label>
        <input
          name="libelle"
          className="form-input flex-1"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.libelle}
        />
        {formik.errors.libelle ? <div className="text-xs text-red-600">
          {formik.errors.libelle}
        </div> : null}
      </div>
    </div>
  );
};

export default EtatChocPage;